import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import appConfig from '../../config/config';
import axios from "axios";
import { Link } from 'react-router-dom';

import {
    FaCheck,FaFile,FaDownload
} from 'react-icons/fa';



function downloadDoc(d,f,t) {
    axios.post(
        appConfig.apiGateway.getDocUrl,
        JSON.stringify({ Action: "File", DOC_ID: d }, null, 2),
        {
            headers :
            {
                'Content-Type': 'application/json',
                //'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
            }
        }
        ).then((response) => {
            const url = response.data.body.dlink;
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', f+'.'+t);
            document.body.appendChild(link);
            link.click();   
            });
        }
class DocumentGrid extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', displayedit : false, docid:0
        };
    }
    editDocument = (e,cell,row) => {
    }
    sentFormatter  (cell, row){
        console.log(cell)
        if (cell == 'Y')

        return (
            <FaCheck  />
            );
        else return(
            <></>
        )
    }
    orderAction=(cell, row)=> {
        return (
                <>
                <Link onClick={(e) => {
                    e.preventDefault(); 
                    downloadDoc(row.id,row.filename, row.filetype); 
                    } }><FaDownload /></Link>

                </>
        );
        //<span onClick={this.saveDataToLocalStorage(post.id)}><FaFile /></span>>
    }
    colHeader = [
        { dataField: 'id', text: 'Sr No' },
        { dataField: 'filename', text: 'Filename' },
        { dataField: 'filedescript', text: 'Description'},
        { dataField: 'sent', text: 'Is Sent', formatter: this.sentFormatter},
        {
            text: 'Action',
            formatter: this.orderAction
        }
    ];
    orderColumns = [
        {
        dataField: 'id',
        text: 'Sr No',
        sort: true
        },
        {
        dataField: 'filename',
        text: 'Filename',
        sort: true
        },
        {
        dataField: 'filetype',
        text: 'Type',
        sort: true,
        hidden: true
        },
        {
        dataField: 'filedescript',
        text: 'Description',
        sort: true
        },
        {
        dataField: 'sent',
        text: 'Is Sent',
        sort: true,
        formatter: this.sentFormatter
        },
        {
        text: 'Action',
        formatter: this.orderAction
        }
    ]


   close () {
       this.setState({...this.state,displayedit:false})
   }
    selectRow = {
        mode: 'checkbox',
        clickToSelect: true,
        //hideSelectColumn: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            console.log(row)
            this.props.SelectDoc(row,isSelect);
        }
    };
    componentDidMount() {
        this.props.reset()
    }
    render() {
        return (
            <>
            <BootstrapTable
                striped
                data={this.props.data}
                columns={this.orderColumns}
                keyField="id"
                selectRow={this.selectRow}
            />
            </>
            );
    }
}
export default DocumentGrid;